export const FIELDS_SHOULD_BE_MAPPED = {
    first_name: true,
    last_name: true,
    phone_number: true,
    email: true,
    address: true
};
